module.exports = __webpack_public_path__ + "img/19.462341bc.svg";